<template>
<v-dialog width="1000" v-model="show">
  <slot slot="activator" name="activator">
  </slot>
  <v-card>
    <v-card-title class="headline" primary-title>
      {{ $t('dir.update_folder') }} : {{ dirView.name }}
    </v-card-title>
    <v-container>
      <DirForm :schemas="schemas" v-on:saved="update($event)" :dirView="dirView" />
    </v-container>
  </v-card>
</v-dialog>
</template>
<script>
import http from '@/plugins/http'
import DirForm from './DirForm'
export default {
  props: ['dirView', 'schemas'],
  components: {
    DirForm
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    update(dir) {
      http.put('dir-view/' + dir.id, dir)
        .then((data) => {
          this.$emit("updated", data.data)
          this.show = false
          this.showMessage(this.$t('dir.updated'), "success")
        })
        .catch(() => this.showMessage(this.$t('dir.update_error'), "danger"))
    },
    showMessage(text, color) {
      this.$store.commit("setSnack", {
        message: text,
        color: color,
      })
    }
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}
</style>
